import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { CryptoService } from '../crypto.service';
import { InputFieldComponent } from '../input-field/input-field.component';
import { HttpClient } from '@angular/common/http';
import { CaesarComponent } from '../caesar/caesar.component';
import { PolybiusComponent } from '../polybius/polybius.component';
import { SkytaleComponent } from '../skytale/skytale.component';
import { MonoalphabeticComponent } from '../monoalphabetic/monoalphabetic.component';
import { VignereComponent } from '../vignere/vignere.component';
import { PigpenComponent } from '../pigpen/pigpen.component';
import { AtbashComponent } from '../atbash/atbash.component';
import { MorseComponent } from '../morse/morse.component';
import { CryptoView } from '../crypto-view';
import { letterFrequencies, trigramFrequencies, bigramFrequencies } from '../../../assets/constant';

@Component({
  selector: 'app-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['../topic-style.css', './playground.component.css']
})
export class PlaygroundComponent extends GeneralComponent {

  @ViewChild('caesar', {static: true})
  private caesar: CaesarComponent;

  @ViewChild('polybius', {static: true})
  private polybius: PolybiusComponent;

  @ViewChild('skytale', {static: true})
  private skytale: SkytaleComponent;

  @ViewChild('monoalphabetic', {static: true})
  private monoalphabetic: MonoalphabeticComponent;

  @ViewChild('setKey', {static: true})
  private setKeyView: MonoalphabeticComponent;

  @ViewChild('vignere', {static: true})
  private vignere: VignereComponent;

  @ViewChild('pigpen', {static: true})
  private pigpen: PigpenComponent;

  @ViewChild('atbash', {static: true})
  private atbash: AtbashComponent;

  @ViewChild('morse', {static: true})
  private morse: MorseComponent;

  private view: CryptoView;

  @ViewChild('inputField', {static: true})
  private inputField: InputFieldComponent;
  exerciseType: string;

  solved = false;
  InputPlainText: string = "";
  plainText: string = "";

  cipherText: string = "";
  method: string;
  modus: string;

  dPlainText: string[] = [];
  dCipherText: string[] = [];

  frequency: any[] = [];
  bigrams: any[] = [];
  trigrams: any[] = [];


  standardFrequencies = letterFrequencies;
  trigramFrequencies = trigramFrequencies;
  bigramFrequencies = bigramFrequencies;

  language: string;

  showStats: boolean = true;
  showBigrams: boolean = false;
  showTrigrams: boolean = false;

  dataFrequencies: any[] = [];
  dataBigram: any[] = [];
  dataTrigram: any[] = [];

  decodeAutomatically = false;

  caretPos: number = 0;
  positionLetter: string;

  errors: number[] = [];

  text: any;

  keyStudent: string;

  keyN: number;
  keyS: string;
  get keyP() {
    if (this.method == "caesar" || this.method == "skytale") {
      return this.keyN;
    }
    if (this.method == "monoalphabetic" || this.method == "vignereLetters" || this.method == "vignereDigits") {
      return this.keyS;
    }
  }

  set keyP(value: any) {
    if (this.method == "caesar" || this.method == "skytale") {
      if (value || value == 0) {
        this.keyN = +value;
      } else {
        this.keyN = undefined;
      }
    }
    if (this.method == "monoalphabetic" || this.method == "vignereLetters" || this.method == "vignereDigits") {
      if (value) {
        this.keyS = value;
      } else {
        this.keyS = undefined;
      }
    }
  }

  hints: string;

  @ViewChild('definitionForm', {static: true}) public definitionForm: NgForm;
  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, protected messageService: MessageService, protected cryptoService: CryptoService, protected http: HttpClient) {
    super(topicService);
    this.loadText();
    this.language = this.topicService.getLanguage();
  }

  /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<string>(textFile)
        .subscribe(response => {
          self.text = response;
          resolve(true);
        })
    })
  }

  reset() {
    this.keyN = undefined;
    this.keyS = undefined;
    this.modus = "normal";
    this.method = undefined;
    this.plainText = undefined;
    this.cipherText = undefined;
    this.solved = false;
    this.showStats = false;
    this.decodeAutomatically = false;
    this.caretPos = 0;
    this.errors = [];
    this.keyStudent = undefined;
  }



  checkSolutionEncode() {
    let solution = this.cryptoService.encode(this.method, this.keyP, this.InputPlainText);
    this.cipherText = this.inputField.getText();
    console.log(this.cipherText);
    console.log(this.InputPlainText);
    console.log(this.method);

    this.errors = solution.split("").map((v, i) => [v, this.cipherText.charAt(i), i]).filter(v => v[0] != v[1]).map(v => +v[2]);
    if (this.method == "polybius") {
      this.errors = this.errors.map((v, i) => Math.floor((v - this.cipherText.substring(0, v).replace(/[^ ]/gi, "").length) / 2 + this.cipherText.substring(0, v).replace(/[^ ]/gi, "").length));
    }
    if (this.method == "skytale") {
      this.errors = this.errors.map((v, i) => Math.floor(v % this.keyP) * (Math.ceil(this.plainText.length / this.keyP)) + Math.floor(v / this.keyP));
    }
    if (this.method == "morse") {
      this.errors = this.errors.map(v => this.cipherText.substring(0, v).split("|").length - 1);
    }
    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("notCorrectlyEncoded"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correctlyEncoded"), "success", 10000);
      this.solved = true;
    }
  }

  onEmitEncode(event) {
    this.caretPos = event;
    this.positionLetter = this.InputPlainText.charAt(this.caretPos);
    if (this.method == "skytale") {
      this.positionLetter = this.caretPos.toString();
      this.caretPos = Math.floor(event % this.keyP) * (Math.ceil(this.InputPlainText.length / this.keyP)) + Math.floor(event / this.keyP);
      while (this.InputPlainText.charAt(this.caretPos) === " ") {
        this.caretPos--;
      }
    }

    if (this.method == "vignere") {
      this.positionLetter = this.caretPos.toString();
    }
  }

  onChangeEncoding() {
    switch (this.method) {
      case "caesar": this.view = this.caesar; break;
      case "polybius": this.view = this.polybius; break;
      case "skytale": this.view = this.skytale; break;
      case "monoalphabetic": this.view = this.monoalphabetic; break;
      case "vignere": this.view = this.vignere; break;
      case "pigpen": this.view = this.pigpen; break;
      case "atbash": this.view = this.atbash; break;
      case "morse": this.view = this.morse; break;
    }
    console.log(this.view);
    if (this.InputPlainText) {
      if (this.method == "vignereDigits") {
        this.InputPlainText = this.cryptoService.normalizeVignereKeys(this.InputPlainText, 'digits');
      } else {
        this.InputPlainText = this.cryptoService.normalizeText(this.InputPlainText);
      }
      this.dPlainText = this.InputPlainText.split("");
    }
    if (this.method && (this.keyP || this.keyP == 0 || this.method == 'polybius' || this.method == 'pigpen' || this.method == 'atbash' || this.method == 'morse')) {
      switch (this.method) {
        case "caesar": {
          if (!(typeof this.keyP == "number")) {
            this.keyP = undefined;
          } else {
            this.keyP = this.keyP % 26;
            if (this.keyP < 0) {
              this.keyP += 26;
            }
          }
          break;
        }
        case "monoalphabetic": {
          if (!(typeof this.keyP == "string")) {
            this.keyP = " ".repeat(26);
            break;
          }
        }
        case "vignereLetters": {
          this.keyP = this.cryptoService.normalizeVignereKeys(this.keyP, 'letters'); break;
        }

        case "vignereDigits": {
          this.keyP = this.cryptoService.normalizeVignereKeys(this.keyP, 'digits'); break;
        }
      }
      if (this.InputPlainText) {
        this.cipherText = this.cryptoService.encode(this.method, this.keyP, this.InputPlainText);
        this.dCipherText = this.cipherText.split("");
        if (this.exerciseType == "encode") {
          this.cipherText = this.cipherText.replace(/[A-z0-9.-]/gi, "#");
          this.caretPos = 0;
          this.onEmitEncode(0);
        }
        if (this.exerciseType == "decode" || this.exerciseType == "withoutKey") {
          this.dPlainText = this.InputPlainText.replace(/[A-z0-9.-]/gi, "#").split("");
          this.plainText = this.InputPlainText.replace(/[A-z0-9.-]/gi, "#");
          this.caretPos = 0;
          this.onEmitDecode(0);
          if (this.exerciseType == "withoutKey") {
            this.cryptoService.computefrequencies(this.frequency, this.bigrams, this.trigrams, this.cipherText);
            this.dataFrequencies = [];
            let index = 0;
            for (let c of this.standardFrequencies[this.language]) {
              this.dataFrequencies.push({
                name: c.key.concat(" ", this.frequency[index].key),
                series: [
                  {
                    name: this.get("standardFrequencies"),
                    value: +c.value
                  },
                  {
                    name: this.get("cipherFrequencies"),
                    value: this.frequency[index].value
                  }
                ]
              });
              index++;
            }
            this.dataBigram = [];
            index = 0;
            for (let c of this.bigramFrequencies[this.language]) {
              this.dataBigram.push({
                name: c.key.concat(" ", this.bigrams[index].key),
                series: [
                  {
                    name: this.get("standardFrequencies"),
                    value: +c.value
                  },
                  {
                    name: this.get("cipherFrequencies"),
                    value: this.bigrams[index].value
                  }
                ]
              });
              index++;
            }
            this.dataTrigram = [];
            index = 0;
            for (let c of this.trigramFrequencies[this.language]) {
              this.dataTrigram.push({
                name: c.key.concat(" ", this.trigrams[index].key),
                series: [
                  {
                    name: this.get("standardFrequencies"),
                    value: +c.value
                  },
                  {
                    name: this.get("cipherFrequencies"),
                    value: this.trigrams[index].value
                  }
                ]
              });
              index++;
            }
          }
        }
      }
    }

    this.onChangeHints();
  }

  generateText() {
    let phrases = this.text.text.split(/[.!?]/).map(v => v.trim()).filter(v => v.length > 0).filter(v => v.length < 150);
    let index = Math.floor(Math.random() * phrases.length);
    this.InputPlainText = this.cryptoService.normalizeText(phrases[index]);
    this.onChangeEncoding();
  }

  generateKey() {
    this.keyS = "";
    this.onChangeHints();
    this.view.resetmapping();
    this.setKeyView.resetmapping();
    let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    this.keyS = "";
    while (chars.length > 0) {
      let i = Math.floor(Math.random() * chars.length);
      this.keyS = this.keyS.concat(chars[i]);
      chars.splice(i, 1);
    }
    this.onChangeEncoding();
  }

  generate01() {
    this.InputPlainText = "";
    for (let i = 0; i < 20; i++) {
      this.InputPlainText = this.InputPlainText.concat(Math.random() > 0.5 ? "1" : "0");
    }
    this.onChangeEncoding();
  }

  generate() {
    this.solved = false;
    switch (this.exerciseType) {
      case "encode": this.generateEncode(); break;
      case "decode": this.generateDecode(); break;
      case "withoutKey": this.generateWithoutKey(); break;
    }
  }

  generateDecode() {
    let methodCode = Math.floor(Math.random() * 8);
    this.keyN = Math.floor(Math.random() * 25 + 1);
    this.generateText();
    switch (methodCode) {
      case 0: this.method = "caesar"; break;
      case 1: this.method = "morse"; break;
      case 2: this.method = "pigpen"; break;
      case 3: this.method = "monoalphabetic"; this.generateKey(); break;
      case 4: this.method = "skytale"; this.keyN = Math.floor(this.keyN / 4) + 1; break;
      case 5: this.method = "polybius"; break;
      case 6: this.method = "vignereLetters"; this.keyS = this.InputPlainText.split(" ")[0]; break;
      case 7: this.method = "vignereDigits"; this.keyS = "1001"; break;

    }
    switch (this.method) {
      case "caesar": this.view = this.caesar; break;
      case "polybius": this.view = this.polybius; break;
      case "skytale": this.view = this.skytale; break;
      case "monoalphabetic": this.view = this.monoalphabetic; break;
      case "vignere": this.view = this.vignere; break;
      case "pigpen": this.view = this.pigpen; break;
      case "atbash": this.view = this.atbash; break;
      case "morse": this.view = this.morse; break;
    }
    this.generateText();
    if (this.method == "vignereDigits") {
      this.generate01();
    }
    this.modus = "normal";
    this.onChangeEncoding();
  }

  generateEncode() {
    let methodCode = Math.floor(Math.random() * 8);
    this.keyN = Math.floor(Math.random() * 25 + 1);
    this.generateText();
    switch (methodCode) {
      case 0: this.method = "caesar"; break;
      case 1: this.method = "morse"; break;
      case 2: this.method = "pigpen"; break;
      case 3: this.method = "monoalphabetic"; this.generateKey(); break;
      case 4: this.method = "skytale"; this.keyN = Math.floor(this.keyN / 4) + 1; break;
      case 5: this.method = "polybius"; break;
      case 6: this.method = "vignereLetters"; this.keyS = this.InputPlainText.split(" ")[0]; break;
      case 7: this.method = "vignereDigits"; this.keyS = "1001"; break;

    }
    switch (this.method) {
      case "caesar": this.view = this.caesar; break;
      case "polybius": this.view = this.polybius; break;
      case "skytale": this.view = this.skytale; break;
      case "monoalphabetic": this.view = this.monoalphabetic; break;
      case "vignere": this.view = this.vignere; break;
      case "pigpen": this.view = this.pigpen; break;
      case "atbash": this.view = this.atbash; break;
      case "morse": this.view = this.morse; break;
    }
    this.generateText();
    if (this.method == "vignereDigits") {
      this.generate01();
    }
    this.modus = "normal";
    this.onChangeEncoding();
  }

  generateWithoutKey() {
    let methodCode = Math.floor(Math.random() * 3);
    this.keyN = Math.floor(Math.random() * 25 + 1);
    switch (methodCode) {
      case 0: this.method = "caesar"; break;
      case 1: this.method = "monoalphabetic"; break;
      case 2: this.method = "skytale"; this.keyN = Math.floor(this.keyN / 4) + 1; break;
    }
    switch (this.method) {
      case "caesar": this.view = this.caesar; break;
      case "polybius": this.view = this.polybius; break;
      case "skytale": this.view = this.skytale; break;
      case "monoalphabetic": this.view = this.monoalphabetic; this.generateKey(); break;
      case "vignere": this.view = this.vignere; break;
      case "pigpen": this.view = this.pigpen; break;
      case "atbash": this.view = this.atbash; break;
      case "morse": this.view = this.morse; break;
    }
    this.generateText();
    if (this.method == "vignereDigits") {
      this.generate01();
    }
    this.modus = "normal";
    this.onChangeEncoding();
  }

  getMethodDescription() {
    switch (this.method) {
      case "caesar": return this.get("useCaesar");
      case "polybius": return this.get("usePolybius");
      case "skytale": return this.get("useSkytale");
      case "monoalphabetic": return this.get("useMonoalphabetic");
      case "vignere": return this.get("useMask");
      case "vignereDigits": return this.get("useMask");
      case "vignereLetters": return this.get("useMask");
      case "pigpen": return this.get("usePigpen");
      case "atbash": return this.get("useAtbash");
      case "morse": return this.get("useMorse");
    }
  }

  onEmitDecode(event) {
    this.caretPos = event;
    this.positionLetter = this.cipherText.charAt(this.caretPos);
    if (this.method == "polybius") {
      this.positionLetter = this.cipherText.substring(this.caretPos, this.caretPos + 2);
    }
    if (this.method == "skytale") {
      this.positionLetter = this.caretPos.toString();
      this.caretPos = Math.floor(event % (Math.floor(this.plainText.length / this.keyP))) * (this.keyP) + Math.floor(event / ((Math.floor(this.plainText.length / this.keyP))));
      while (this.plainText.charAt(this.caretPos) === " ") {
        this.caretPos--;
      }
    }
    if (this.method == "vignere") {
      this.positionLetter = this.caretPos.toString();
    }
    if (this.method == "morse") {
      console.log(this.cipherText.split("|")[this.caretPos]);
      this.positionLetter = this.cryptoService.decode(this.method, null, this.cipherText.split("|")[this.caretPos]);
      console.log(this.positionLetter);
    }
  }

  decode() {
    if (this.decodeAutomatically) {
      this.plainText = this.cryptoService.decode(this.method, this.keyStudent, this.cipherText);
    }
  }

  changeMonoalphabeticKey(key: any) {
    if (this.method == "monoalphabetic") {
      this.keyStudent = key;
      this.plainText = this.cipherText.split("").map(v => (v === " ") ? v : this.keyStudent.charAt(v.charCodeAt(0) - 65) == " " ? "#" : this.keyStudent.charAt(v.charCodeAt(0) - 65)).join("");
      this.inputField.text = this.plainText;
    }
  }

  fillKey(input: string[]) {
    let mapping: any = this.view.getMapping();
    let cipher = this.cipherText.charAt(+input[1]);
    let plain = this.cryptoService.normalizeText(input[0]);
    mapping = mapping.split("");
    if (plain == "#") {
      mapping[input[0].charCodeAt(0) - 65] = " ";
    } else {
      mapping[cipher.charCodeAt(0) - 65] = plain;
    }
    this.view.setmapping(mapping.join(""));
    this.changeMonoalphabeticKey(this.view.getMapping());
  }

  onChangeHints() {
    if (this.exerciseType == "withoutKey" && this.method && (this.keyP || this.keyP == 0) && this.hints != undefined) {
      this.hints = this.cryptoService.normalizeText(this.hints);
      let hintsToWrite = [];
      for (let hint of this.hints) {
        hintsToWrite[this.cryptoService.decode(this.method, this.keyP, hint).charCodeAt(0) - 65] = hint;
      }
      this.view.setHints(hintsToWrite);
      this.setKeyView.setHints(hintsToWrite);
      if (this.method == "monoalphabetic") {
        this.changeMonoalphabeticKey(this.view.getMapping());
      }
    }
  }

  checkSolution() {
    switch (this.exerciseType) {
      case "encode": this.checkSolutionEncode(); break;
      case "decode": this.checkSolutionDecode(); break;
      case "withoutKey": this.checkSolutionWithoutKey(); break;
    }
  }

  checkSolutionDecode() {
    let solution = this.cryptoService.decode(this.method, this.keyP, this.cipherText);
    this.plainText = this.inputField.getText();
    this.errors = solution.split("").map((v, i) => [v, this.plainText.charAt(i), i]).filter(v => v[0] != v[1]).map(v => +v[2]);
    if (this.method == "polybius") {
      this.errors = this.errors.map((v, i) => (v - this.plainText.substring(0, v).replace(/[^ ]/gi, "").length) * 2 + this.plainText.substring(0, v).replace(/[^ ]/gi, "").length);
    }
    if (this.method == "skytale") {
      this.errors = this.errors.map((v, i) => Math.floor(v % (Math.floor(this.plainText.length / this.keyP))) * (this.keyP) + Math.floor(v / ((Math.floor(this.plainText.length / this.keyP)))));
    }
    if (this.method == 'morse') {
      let temp = this.errors.map(v => this.createArray(this.cipherText.split("|")[v].length).map((u) => this.cipherText.split("|").slice(0, v).join("|").length + 1 + u));
      this.errors = [].concat(...temp);
      console.log(this.errors);
    }
    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("notCorrectlyDecoded"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correctlyDecoded"), "success", 10000);
      this.solved = true;
    }
  }

  checkSolutionWithoutKey() {
    if (this.keyStudent != this.keyP) {
      if (this.method != "monoalphabetic") {
        this.messageService.addAlertWithTimeout(this.get("wrongKey"), "danger", 10000);
      } else {
        let keyError = false;
        for (let i = 0; i < this.keyStudent.length; i++) {
          if (this.cipherText.includes(String.fromCharCode(i + 65)) && this.cryptoService.decode(this.method, this.keyP, String.fromCharCode(i + 65)) != this.cryptoService.encode(this.method, this.keyStudent, String.fromCharCode(i + 65))) {
            keyError = true;
          }
        }
        if (keyError) {
          this.messageService.addAlertWithTimeout(this.get("wrongKey"), "danger", 10000);
        }
      }
    }
    let solution = this.cryptoService.decode(this.method, this.keyP, this.cipherText);
    this.plainText = this.inputField.text;
    this.errors = solution.split("").map((v, i) => [v, this.plainText.charAt(i), i]).filter(v => v[0] != v[1]).map(v => +v[2]);
    if (this.method == "skytale") {
      this.errors = this.errors.map((v, i) => Math.floor(v % (Math.floor(this.plainText.length / this.keyP))) * (this.keyP) + Math.floor(v / ((Math.floor(this.plainText.length / this.keyP)))));
    }
    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("notCorrectlyDecoded"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correctlyDecoded"), "success", 10000);
      this.solved = true;
    }
  }
}